import React, { useEffect, useState } from 'react'
import { Validator } from './validators'

type ValidationOptions = {
  validators: Validator[]
  fieldRef: React.RefObject<HTMLInputElement>
}

export type Validation = {
  isValid: boolean,
  errors: string[]
}

export const useValidation = ({
  validators,
  fieldRef
}: ValidationOptions): Validation => {
  const [isDirty, setIsDirty] = useState(false)
  const [isValid, setIsValid] = useState(true)
  const [errors, setErrors] = useState<string[]>([])
  const [value, setValue] = useState(fieldRef.current?.value)

  useEffect(() => {
    function handleChange(this: HTMLInputElement) {
      setIsDirty(true)
      setValue(this.value)
    }

    if (validators.length > 0) {
      const field = fieldRef.current
  
      field?.addEventListener('input', handleChange)
  
      return () => field?.removeEventListener('input', handleChange)
    }
  }, [fieldRef, validators])

  useEffect(() => {
    if (isDirty && validators.length > 0) {
      const results = validators.map(validator => validator(value))
      const allValidationsPassed = results.every(([ valid ]) => valid)
      const errorMessages = results.filter(([ valid ]) => !valid).map(([, message]) => message)
      
      setIsValid(allValidationsPassed)
      setErrors(errorMessages)
    }
  }, [isDirty, value, validators])

  return {
    isValid,
    errors
  }
}
